import { differenceInHours } from 'date-fns';

import { highPriorityRules, mediumPriorityRules } from '../../domain';
import {
    DisplayDossierOverview,
    DisplayDossierOverviews,
    NormalizedDossier,
} from '../dossier/types';
import { formatDossierOverview } from '../dossier/operations';
import { filterDossiersByQuery } from '../filters/selectors';
import { Query } from '../../design-system/types';

import { Priority } from './types';

export const getPriorityFromDossier = (
    dossier: DisplayDossierOverview,
    currentDate: number,
): Priority => {
    if (highPriorityRules(currentDate).some((rule) => rule(dossier))) {
        return 'high';
    }
    if (mediumPriorityRules(currentDate).some((rule) => rule(dossier))) {
        return 'medium';
    }
    return 'low';
};

export const getDurationInHoursBetweenRequestDateAndToday = (
    currentDate: Date,
    requestDate: Date | null,
): number => {
    if (!requestDate) {
        return 0;
    }

    let durationInHoursBetweenRequestDateAndToday = differenceInHours(currentDate, requestDate);

    if (durationInHoursBetweenRequestDateAndToday === 0) {
        durationInHoursBetweenRequestDateAndToday = 1;
    }

    return durationInHoursBetweenRequestDateAndToday;
};

export const formatDossierAndFilterByQuery =
    (query: Query, userId: number | string | null) =>
    (dossiers: NormalizedDossier): DisplayDossierOverviews => {
        const formattedDossiers = Object.values(dossiers).map((dossier) =>
            formatDossierOverview({ dossierOverview: dossier }),
        );
        return filterDossiersByQuery(query, userId)(formattedDossiers);
    };
